const WorkBgFour = () => {
  return (
    <div className="work_bg4 bg_img">
      <svg
        width="173"
        height="389"
        viewBox="0 0 173 389"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="bg"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-78.612 248.8C-85.8066 236.862 -98.6413 230.149 -105.962 218.288C-114.993 203.657 -129.467 188.76 -126.058 171.93C-122.659 155.147 -101.912 149.149 -89.5601 137.299C-77.1566 125.399 -67.9894 111.049 -53.2964 102.122C-32.8976 89.7292 -9.03246 63.9143 11.734 75.7589C33.8262 88.3596 20.0751 124.539 28.2217 148.618C33.3312 163.72 45.9037 174.626 50.3621 189.932C55.8643 208.822 63.373 228.775 56.9844 247.361C50.2122 267.064 32.6144 280.656 15.2313 292.14C-3.69858 304.645 -26.4009 325.603 -47.031 316.076C-69.9928 305.471 -65.5589 270.46 -78.612 248.8Z"
        />
        <path
          className="line"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-80.327 258.744C-88.1873 245.295 -102.531 237.927 -110.536 224.569C-120.41 208.091 -136.423 191.431 -132.204 172.173C-127.997 152.97 -104.44 145.677 -90.2321 131.898C-75.9654 118.061 -65.2988 101.503 -48.5126 91.0054C-25.2078 76.4308 2.3065 46.4818 25.4926 59.5245C50.1589 73.4 33.8358 114.939 42.5035 142.204C47.9399 159.305 61.895 171.459 66.5917 188.806C72.388 210.215 80.4264 232.792 72.8038 254.117C64.7234 276.723 44.5546 292.603 24.6748 306.075C3.026 320.745 -23.0683 345.133 -46.1515 334.728C-71.8436 323.147 -66.0662 283.144 -80.327 258.744Z"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
};

export default WorkBgFour;
